module.exports = "<h2 class=\"gw-titles-subtitle\" ng-class=\"{ 'gw-titles-subtitle_offset': hasOffset }\">\n    <ng-transclude></ng-transclude>\n</h2>"